import { Button } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';

const ColorButtonWhite = withStyles(() => ({
  root: {
    color: '#9B88FF',
    borderColor: '#9B88FF',
    backgroundColor: '#FFFF',
    borderRadius: 0,
    boxShadow: 'none',
    fontFamily: 'Noto Sans JP',
    width: 110,
    '&:hover': {
      color: '#FFFF',
      backgroundColor: '#9B88FF',
    },
  },
}))(Button);

export default ColorButtonWhite;
